export const END_MATCH_DELIMITER = String.fromCharCode(0xe001); // This char marks end of highlighting
export const START_MATCH_DELIMITER = String.fromCharCode(0xe000); // This char marks start of highlighting
export const SEARCHBOX_ID = 'searchBoxId';
